import React from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

const linkClass =
  'inline-flex min-h-[44px] items-center justify-center px-1 hover:text-orange-500 hover:scale-110';

const titleClass = 'm-0 text-sm font-semibold sm:text-base md:text-xl';

export default function Header(props) {
  const { tecnologias, contatos, appsBackEnd, homePage, langSwitcher } = props;

  return (
    <div
      className={`relative flex flex-wrap items-center justify-center gap-x-3 gap-y-2 bg-gray-700 px-3 py-3 text-white sm:gap-x-6 md:gap-x-8 ${
        langSwitcher ? 'pr-20 sm:pr-24' : ''
      }`}
    >
      {homePage && (
        <Link className={linkClass} to="/">
          <h3 className={titleClass}>{homePage}</h3>
        </Link>
      )}

      {tecnologias && (
        <Link className={linkClass} to="/tecnologias">
          <h3 className={titleClass}>{tecnologias}</h3>
        </Link>
      )}
      {contatos && (
        <Link className={linkClass} to="/contatos">
          <h3 className={titleClass}>{contatos}</h3>
        </Link>
      )}
      {appsBackEnd && (
        <Link className={linkClass} to="/backEnd">
          <h3 className={titleClass}>{appsBackEnd}</h3>
        </Link>
      )}

      {langSwitcher && (
        <LanguageSwitcher className="absolute right-3 top-1/2 -translate-y-1/2" />
      )}
    </div>
  );
}
